import {t} from 'app/translations';
import {EskotValidator} from 'utils/eskot-validator';
import {Errors} from 'utils/validator';

import {SubjectManagementFormValues} from '../types/subject-management-form-values';

const te = t('admin');

/**
 * Validates association-management form values.
 *
 * @param values Association-management form state.
 * @returns Validation errors keyed by form field.
 */
export const managementAssociationsValidate = (
    values: SubjectManagementFormValues,
): Errors<SubjectManagementFormValues> => {
    const validator = new EskotValidator(values);
    const approveIsInvalid = (
        values.approvedFrom !== null
        && values.approvedTo !== null
        && values.approvedFrom > values.approvedTo
    );

    validator.nonEmpty('approvedFrom', te('approvedFrom'));
    validator.customRule(
        'approvedTo',
        approveIsInvalid,
        te('dateFromToIsInvalid'),
    );
    validator.nonEmpty('userProfileId', te('loginName'));
    validator.nonEmpty('roleIds', te('roles'));

    return validator.generateErrorsObject();
};
